import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-hot-toast';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format } from 'date-fns';
import apiClient from '../api/client';

const API_BASE_URL = sessionStorage.getItem("API_BASE_URL");

function ThreadTab({ ticketId, domain }) {
  const [threads, setThreads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({
    createdOn: '',
    createdBy: sessionStorage.getItem("username"),
    text: '',
    status: '',
  });

  const token = localStorage.getItem('token');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await apiClient.post(`/api/tickets/history`, {
          domain, ticketId: Number(ticketId) });
        setThreads(res.data || []);
      } catch (err) {
        toast.error('Failed to load threads');
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [ticketId, domain, token]);

  const handleInsert = async () => {
    if (!form.text.trim()) {
        toast.error("Text / Description is required");
        return;
    }
    const username = sessionStorage.getItem("username");
    try {
        const payload = {
        domain,
        ticketId,
        status: form.status || "Open",
        description: form.text.trim(),
        estimatedDelivery: form.createdOn ? new Date(form.createdOn).toISOString().split('T')[0] : null,
        createdBy: username,
        isInternal: false
        };

       await apiClient.post(`/api/tickets/thread/add`, payload);

        toast.success('Thread added');
        setShowForm(false);
        setForm({ createdOn: '', createdBy: '', text: '', status: '', reminderId: '' });

        const res = await apiClient.post(`/api/tickets/history`, {
        domain, ticketId: Number(ticketId) });
        setThreads(res.data || []);
    } catch (err) {
        console.error(err.response?.data);
        toast.error('Failed to add thread: ' + (err.response?.data?.detail || 'Unknown error'));
    }
  };

  if (loading) return <div className="text-center py-4">Loading threads...</div>;

  return (
    <div>
      <button 
        className="btn btn-success btn-sm me-2"
        onClick={() => setShowForm(!showForm)}
      >
        {showForm ? 'Cancel' : 'Add new record'}
      </button>

      {showForm && (
        <div className="bg-white p-4 border rounded mb-4">
            <div className="row g-3 mb-3">
            <div className="col-md-4">
              <label className="form-label small fw-semibold">Created On</label>
              <DatePicker
                selected={form.createdOn ? new Date(form.createdOn) : null}
                onChange={(date) => {
                  setForm({
                    ...form,
                    createdOn: date ? format(date, 'yyyy-MM-dd') : ''
                  });
                }}
                dateFormat="MM/dd/yyyy"
                placeholderText="MM/DD/YYYY"
                className="form-control form-control-sm"
                wrapperClassName="w-100"
                isClearable
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
              />
            </div>

            <div className="col-md-4">
                <label className="form-label small fw-semibold">Created By</label>
                <input
                className="form-control form-control-sm"
                placeholder="Created By"
                value={form.createdBy}
                onChange={e => setForm({ ...form, createdBy: e.target.value })}
                />
            </div>

            <div className="col-md-4">
                <label className="form-label small fw-semibold">Status</label>
                <input
                className="form-control form-control-sm"
                placeholder="e.g. Open, Closed, Support ..."
                value={form.status}
                onChange={e => setForm({ ...form, status: e.target.value })}
                />
            </div>
            </div>

            <div className="mb-3">
            <label className="form-label small fw-semibold">
                Description <span className="text-danger">*</span>
            </label>
            <textarea
                className="form-control form-control-sm"
                rows="3" 
                placeholder="Enter thread/reply text here..."
                value={form.text}
                onChange={e => setForm({ ...form, text: e.target.value })}
            />
            </div>

            <div className="mt-3">
            <button className="btn btn-success btn-sm me-2" onClick={handleInsert}>
                Insert
            </button>
            <button className="btn btn-secondary btn-sm" onClick={() => setShowForm(false)}>
                Cancel
            </button>
            </div>
        </div>
      )}

      <table className="table table-sm table-bordered table-hover">
          <thead style={{ backgroundColor: '#0aa375', color: 'white' }}>
            <tr>
                <th style={{ fontWeight: 'normal' }}>Created On</th>
                <th style={{ fontWeight: 'normal' }}>Created By</th>
                <th style={{ fontWeight: 'normal' }}>Text</th>
                <th style={{ fontWeight: 'normal' }}>Status</th>
            </tr>
          </thead>
        <tbody>
          {threads.map((item, i) => (
            <tr key={i}>
              <td>{item.dtRaisedOn || '—'}</td>
              <td>{item.updatedBy || '—'}</td>
              <td>{item.szDescription || '—'}</td>
              <td>{item.szStatus || '—'}</td>
            </tr>
          ))}
          {threads.length === 0 && (
            <tr><td colSpan={5} className="text-center py-3">No threads found</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default ThreadTab;